class FacetsSticky extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const facetsStickyHeight = this.offsetHeight;
    const stickyHeaderEl = document.querySelector('sticky-header');
    const productContainerEl = document.querySelector(".product-grid-container");
    const facetsSummaryEl = document.querySelector('summary.mobile-facets__open-wrapper');
    const facetsStickySummaryEl = this.querySelector('.tw-btn-filters');
    const sortByEl = document.querySelector(".mobile-sort-form #SortBy");
    const sortByStickyEl = this.querySelector('#SortBySticky');
    let previousDocumentScrollTop = null;
    let previousSortedQueryString = null;

    facetsStickySummaryEl?.addEventListener('click', () => {
      previousDocumentScrollTop = document.documentElement.scrollTop;
      previousSortedQueryString = this.getSortedQueryString();
      facetsSummaryEl?.click();
    });

    facetsSummaryEl?.addEventListener('focus', () => {
      if (facetsSummaryEl.getAttribute('aria-expanded') == 'false' && previousDocumentScrollTop && previousSortedQueryString === this.getSortedQueryString()) {
        window.scrollTo(0, previousDocumentScrollTop);
        previousDocumentScrollTop = null;
        previousSortedQueryString = null;
      }
    });

    if (sortByEl && sortByStickyEl) {
      sortByStickyEl.addEventListener("change", (event) => {
        sortByEl.value = event.target.value;
        sortByEl.closest('form')?.dispatchEvent(new Event('input'));
      });

      sortByEl.addEventListener("change", (event) => {
        sortByStickyEl.value = event.target.value;
      });
    }

    if (stickyHeaderEl) {
      this.style.setProperty('top', `${stickyHeaderEl.offsetHeight - facetsStickyHeight}px`);

      if (window.matchMedia('(max-width: 1023px)').matches && productContainerEl) {
        window.addEventListener('scroll', function() { 
          let stickyHeaderDOMRect = stickyHeaderEl.getBoundingClientRect();
          let productContainerDOMRect = productContainerEl.getBoundingClientRect();

          if (stickyHeaderDOMRect.top > productContainerDOMRect.bottom - stickyHeaderEl.offsetHeight - facetsStickyHeight || stickyHeaderDOMRect.bottom < productContainerDOMRect.top) {
            this.style.setProperty('transform', 'translateY(0px)');
          } else {
            this.style.setProperty('visibility', 'visible');
            this.style.setProperty('transform', `translateY(${facetsStickyHeight}px)`);
          }
        }.bind(this));
      }
    }
  }

  getSortedQueryString() {
    let searchParams = new URLSearchParams(window.location.search);
    searchParams.sort();

    return searchParams.toString();
  }
}

customElements.define('facets-sticky', FacetsSticky);